import * as React from 'react';
import NotificationModule from '../../uiComponents/layout/Notification';
import { Redirect } from 'react-router-dom';
import OpgavepakkePresenter from './OpgavepakkePresenter';
import { Opgavepakke } from '../../models/Opgavepakke';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { Spinner } from '../../uiComponents/Spinner';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { RouteComponentProps } from 'react-router';
import { OpgaveListItem } from '../../models/OpgaveListItem';
import { Logbog } from '../../models/Logbog';
import { Guid } from '../../infrastructure/Guid';
import { EditorStateModel } from '../../models/EditorStateModel';
import { VejledningAfsnit } from '../../models/VejledningAfsnit';
import DraftHelper from '../../infrastructure/DraftHelper';
import { EditorState } from 'draft-js';

export interface OpgavepakkeUpdateContainerProps extends RouteComponentProps<any> {
}

export class OpgavepakkeUpdateContainerState {
    opgavepakke?: Opgavepakke;
    opgaver?: OpgaveListItem[];
    editorStates: EditorStateModel[];
    logboeger?: Logbog[];
    validationResult?: ValidationResult;
    isSaved: boolean;
    isSubmitting: boolean;
}

class OpgavepakkeUpdateContainer extends React.Component<OpgavepakkeUpdateContainerProps, OpgavepakkeUpdateContainerState> {
    constructor(props: OpgavepakkeUpdateContainerProps) {
        super(props);

        const newState = new OpgavepakkeUpdateContainerState();
        newState.opgavepakke = undefined;
        newState.isSaved = false;
        newState.editorStates = new Array();
        this.state = newState;

        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onAddAfsnit = this.onAddAfsnit.bind(this);
        this.onAfsnitRemoved = this.onAfsnitRemoved.bind(this);
        this.onEditorChanged = this.onEditorChanged.bind(this);
        this.onVejledningChanged = this.onVejledningChanged.bind(this);
    }

    componentDidMount() {
        const opgavepakkeId = this.props.match.params.id;
        const self = this;
        const apiCaller = createApiCaller();

        apiCaller.getOpgavepakke(opgavepakkeId).then(response => {
            response.opgavepakkeOpgaver.forEach(o => o.uiId = Guid.newGuid());
            self.setState({ 
                opgavepakke: response, 
                editorStates: self.getEditorStates(response.vejledning.afsnit) 
            });
        });

        apiCaller.getLogboeger().then(response =>
            self.setState({ logboeger: response })
        );

        apiCaller.getOpaveListItems().then(response =>
            self.setState({ opgaver: response })
        );      
    }

    getEditorStates = (afsnit: VejledningAfsnit[]) => {
        return afsnit.map((a, i) => {
            const editorstateModel = new EditorStateModel();
            editorstateModel.editorState = DraftHelper.getContentAsEditorState(a.editorStateJson);
            editorstateModel.index = i;
            return editorstateModel;
        });
    }

    onChange(fieldName: string, value: any) {
        const opgavepakke = this.state.opgavepakke;
        if (opgavepakke === undefined) {
            return;
        }
        opgavepakke[fieldName] = value;

        this.setState({ opgavepakke: opgavepakke });
    }

    onSave() {
        const opgavepakke = this.state.opgavepakke;
        if (opgavepakke === undefined) {
            return;
        }
        this.setState({ isSubmitting: true });
        const self = this;
        createApiCaller().updateOpgavepakke(opgavepakke).then(response =>
            self.setState({ validationResult: response, isSaved: response.isValid, isSubmitting: false })
        );
    }
    onAfsnitRemoved(index: number) {
        const tmpState = this.state;

        if (tmpState.opgavepakke !== undefined) {
            if (tmpState.opgavepakke.vejledning !== undefined) {
                tmpState.opgavepakke.vejledning.afsnit.splice(index, 1);
                this.setState(tmpState);
            }
        }
    }

    onAddAfsnit() {
        const tmpState = this.state;

        if (tmpState.opgavepakke !== undefined) {
            if (tmpState.opgavepakke.vejledning !== undefined) {
                const afsnit = new VejledningAfsnit();
                afsnit.overskrift = '';
                afsnit.editorStateJson = '';
                tmpState.opgavepakke.vejledning.afsnit.push(afsnit);
                const editorStateModel = new EditorStateModel();
                editorStateModel.editorState = DraftHelper.getEmptyEditorState();
                editorStateModel.index = tmpState.editorStates.length;
                tmpState.editorStates.push(editorStateModel);
                this.setState(tmpState);
            }
        }
    }

    onVejledningChanged = (index: number, fieldName: string, value: any) => {
        const tmpState = this.state;

        if (tmpState.opgavepakke !== undefined) {
            if (tmpState.opgavepakke.vejledning !== undefined) {
                const afsnit = tmpState.opgavepakke.vejledning.afsnit[index];
                if (afsnit !== undefined) {
                    afsnit[fieldName] = value;
                    this.setState(tmpState);
                }
            }
        }
    }

    onEditorChanged = (index: number, editorState: EditorState): void => {
        if (this.state.opgavepakke !== undefined) {
            if (this.state.opgavepakke.vejledning !== undefined) {
                const vejledning = this.state.opgavepakke.vejledning;
                const editorStates = this.state.editorStates;
                const editorStateModel = editorStates[index];

                if (editorStateModel !== undefined) {
                    editorStateModel.editorState = editorState;
                }

                const afsnit = vejledning.afsnit[index];

                if (afsnit !== undefined) {
                    afsnit.editorStateJson = DraftHelper.getEditorStateAsJson(editorState);
                }

                const opgavepakke = this.state.opgavepakke;
                opgavepakke.vejledning = vejledning;

                this.setState({ editorStates: editorStates, opgavepakke: opgavepakke });
            }
        }
    }

    render() {
        if (this.state.opgavepakke === undefined) {
            return <Spinner />;
        } else {
            if (this.state.isSaved) {
                NotificationModule.showSuccess('', 'Opgavepakke er opdateret', false);
                return <Redirect to='/opgavepakker' />;
            } else {
                return (
                    <OpgavepakkePresenter
                        opgavepakke={this.state.opgavepakke}
                        errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                        onChange={this.onChange}
                        onSave={this.onSave}
                        opretRediger='Rediger'
                        isSubmitting={this.state.isSubmitting}
                        opgaver={this.state.opgaver === undefined ? [] : this.state.opgaver.filter(o => o.aktiv)}
                        logboeger={this.state.logboeger === undefined ? [] : this.state.logboeger}
                        isSaved={this.state.isSaved}
                        editorStates={this.state.editorStates}
                        validationResult={this.state.validationResult === undefined ? new ValidationResult : this.state.validationResult}
                        onAddAfsnit={this.onAddAfsnit}
                        onAfsnitRemoved={this.onAfsnitRemoved}
                        onEditorChanged={this.onEditorChanged}
                        onVejledningChanged={this.onVejledningChanged}
                    />
                );
            }
        }

    }
}

export default OpgavepakkeUpdateContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgavepakke/OpgavepakkeUpdateContainer.tsx